import { render, staticRenderFns } from "./JoinForm.vue?vue&type=template&id=5b2023a8&"
import script from "./JoinForm.vue?vue&type=script&lang=ts&"
export * from "./JoinForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports